module.exports = __webpack_public_path__ + "media/images/story/top/service_title-304e4960bb0400037f4c6ab0cd052751.svg";